import { render, staticRenderFns } from "./detailsNews.vue?vue&type=template&id=7c6aadc3&scoped=true"
import script from "./detailsNews.vue?vue&type=script&lang=js"
export * from "./detailsNews.vue?vue&type=script&lang=js"
import style0 from "./detailsNews.vue?vue&type=style&index=0&id=7c6aadc3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6aadc3",
  null
  
)

export default component.exports